"use client";
import { jsx as s } from "react/jsx-runtime";
import { collapseVariants as c } from "./Collapse.variants.js";
const f = ({
  children: o,
  className: l,
  isExpanded: a = !1,
  withTransition: e = !1,
  ...r
}) => {
  const { root: t } = c;
  return /* @__PURE__ */ s(
    "div",
    {
      "aria-hidden": !a,
      className: t({ className: l, isExpanded: a, withTransition: e }),
      "data-is-expanded": a,
      "data-with-transition": e,
      ...r,
      children: e ? /* @__PURE__ */ s("div", { className: "overflow-hidden", children: o }) : o
    }
  );
};
export {
  f as Collapse
};
